import React, { useEffect, useRef, useState, KeyboardEvent } from 'react';
import DataGrid, { MasterDetail, IDataGridOptions, Column, Sorting } from 'devextreme-react/data-grid';
import styles from './aea-master-data-grid.module.scss';
import { Constants, Enums, numeral, Utilities } from '@utils';
import dxDataGrid from 'devextreme/ui/data_grid';
import { Tooltip } from 'devextreme-react';
import { Toast } from "devextreme-react/toast";
interface IMasterDataGrid extends IDataGridOptions{
    id: string;
    keyExpr?: string;
    columns: any;
    dataSource: any;
    gridProps?: IDataGridOptions;
    render?: any;
    allowCode?: string;
    gridTitle?: string;
    gridHelpId?: string;
    gridHelpText?: string;
    saveTable?(gridInstance: dxDataGrid): void;
    getDuplicateCalculation?(column: any): void;
    setAuxAlert?(id: string): void;
    onRefChange?: any
    idTour?: string;
    idTitle?: string;
    expandAll?: boolean;
    infoMessage?: string;
    validateCero?: boolean;
}

const MasterDataGrid: React.FC<IMasterDataGrid> = (props) => {
    const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});
    const onHidingToast = () => {
        setToastConfig({
			...toastConfig,
			isVisible: false,
		});
	};

    const _dxGrid = useRef<DataGrid>();

    const getColumns = () => {        
        if(props.columns === undefined) return <></>
        if(props.columns.length > 0){
            return props.columns.map((column: any, index:number) => {
                const newProps = {...column, cellTemplate: (container: any, _props: any) => renderCellTemplate(container, _props, column)};
                if(!column.allowEditing || props.allowCode === Enums.FollowupState.view){
                    newProps.cssClass = styles.readOnly;
                    newProps.allowEditing = false;
                }                
                if(column.columns !== undefined ){
                    newProps.columns = column.columns.map((child:any, index:number) => {
                        if(!child.allowEditing || props.allowCode === Enums.FollowupState.view){
                            child.cssClass = styles.readOnly;
                            child.allowEditing = false;
                        }
                        return {...child, cellTemplate: (container: any, _props: any) => renderCellTemplate(container, _props, child)};
                    });
                }

                if(newProps.dataType === Enums.FieldTypes.Boolean) delete newProps.cellTemplate; 
                return (
                    <Column key={index} {...newProps}>
                        {props.getDuplicateCalculation?.(column)}
                    </Column>
                )
            });
        } 
        return <></>;
    }  

    const renderCellTemplate = (container: any,  options: any, column: any) => {
        const monthsEn = Constants.Months.English
        let _value = options.value;
        let symStart = "", symEnd = ""
        if(column.format){
            if(column.format.includes('€')){
                if(column.format[0] === '€') symStart = '€'
                else symEnd = '€'
                column.format.replace('€', '')
            }
            container.textContent = (!Utilities.isNullEmptyObject(_value) || column.dataType === Enums.FieldTypes.Percentage) ? `${symStart} ${numeral(_value).format(column.format)} ${symEnd}` : ''
            container.textContent = container.textContent?.trim() 
        }else{
            if(column.dataType === Enums.FieldTypes.Number && options?.key?.isPercentage && !Utilities.isNullEmptyObject(options.text)){
                container.textContent = numeral(Number(options.text)).format(Constants.GeneralFormats.PERCENTAGE_FORMAT)
            }else container.textContent = options.text || null
        }

        if(column.dataField === Enums.FollowupBasicFields.criteria && options?.data?.isMainLineTour) container.id = "IndicatorsTourStep8"
        if(column.dataField === Enums.FollowupBasicFields.indicator && options?.data?.isProductLineTour) container.id = "IndicatorsTourStep11"
        if(options?.data?.isResultTour) container.id = "BeneficiariesTourStep6"
        if(options?.data?.isOverlapTour) container.id = "BeneficiariesTourStep8"
        if(options?.data?.isOverChildTour) container.id = "BeneficiariesTourStep9"
        if(options?.data?.isTotalBen) container.id = "BeneficiariesTourStep10"
        if(options?.data?.isTotalMonth) container.id = "BeneficiariesTourStep11"
        if(column.dataField === Enums.FollowupBasicFields.currentBudgetMod && options?.data?.isActivityTour) container.id = "FinancialTourStep5"
        if(column.dataField === Enums.FollowupBasicFields.januaryPl && options?.data?.isActivityTour) container.id = "FinancialTourStep6"
        if(column.dataField === Enums.FollowupBasicFields.result && options?.key?.section === 'benResult') container.classList.add(styles.truncateText)
        if(monthsEn.includes(column.dataField?.split('Pl')?.[0])) container.classList.add(styles.heigthPl)

        if (!Utilities.isNullObject(column.onValueChanged) && options.row?.modified && column.dataField === Enums.FollowupBasicFields.actualAchievedGoal) {
            if(!toastConfig.isVisible && options.value === 0){
                setToastConfig({
                    isVisible: true,
                    type: 'info',
                    message: props.infoMessage || ''
                })
            }
        }
    }

    const customEditorPreparing = (e: any)=> {
        if (e.parentType === 'dataRow') {
            const defaultValueChangeHandler = e.editorOptions.onValueChanged;
            e.editorOptions.onValueChanged = function (args: any) { 
                if ((e.dataType == Enums.FieldTypes.Number) && (args.value != null && args.value != undefined && args.value != "")){
                    if (args.value < 0)
                        e.setValue(0);
                    else 
                        defaultValueChangeHandler(args);
                } else 
                    defaultValueChangeHandler(args);
            }

            e.editorOptions.onKeyDown = function (args: any) { 
                if ((e.dataType == Enums.FieldTypes.Number)){
                    if (args.event.key === ',') {
                        args.event.preventDefault()
                    }
                }
            }
        }
    }

    let toolbarGridProps = props.gridProps;

    if ((props.gridTitle || props.gridHelpId) && toolbarGridProps){
        toolbarGridProps.paging = {enabled: false}

        toolbarGridProps.onToolbarPreparing = (e:any) => {
            if (props.gridTitle)
                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: `<h6 style="color:rgb(240, 53, 0)" id=${props.idTitle ? props.idTitle : ''} >`+props.gridTitle+'</h6>',
                });

            if(!!props.idTour){
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    template: `<h6 id="${props.idTour}" ></h6>`,
                    widget: 'dxButton',
                    
                });
            } 
            if (props.gridHelpId){
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon: "info",
                        onInitialized: (e:any) => {
                            e.element.setAttribute("id", props.gridHelpId);
                        }
                    }
                });
                
            }

            // Change default saveButton to save in SharePoint
            let toolbarItems = e.toolbarOptions.items; 
            toolbarItems.forEach(function(item: any) {                    
              if (item.name === "saveButton") {
                item.options.onClick = async (e: any) => { 
                    let instance = _dxGrid.current.instance;
                    await instance.saveEditData();
                    
                    if (props.saveTable){
                        props.saveTable(_dxGrid.current.instance);
                    }
                }
              }
            });
        };
    }

    useEffect(() => {
      if(props.onRefChange) props.onRefChange(_dxGrid)
    }, [_dxGrid])

    const handleCellClick = (e: any)=> {
        if (!Utilities.isNullObject(e?.column?.onValueChanged) && e?.column?.dataField === Enums.FollowupBasicFields.actualAchievedGoal && e?.isEditing) {
            if(e.value === 0 && !toastConfig.isVisible){
                setToastConfig({
                    isVisible: true,
                    type: 'info',
                    message: props.infoMessage || ''
                })
            }
        }
    }

    return (
        <>
            <DataGrid
                ref={_dxGrid}
                onCellClick={props.onCellClick || handleCellClick}
                id={props.id}
                keyExpr={props.keyExpr}
                dataSource={props.dataSource}
                rowAlternationEnabled={false}
                showRowLines={true}
                wordWrapEnabled={true}
                showBorders={true} 
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnMinWidth={100}
                className={styles.gridContainer}
                columnFixing={{ enabled: true}}
                onEditorPreparing={customEditorPreparing}
                
                {...toolbarGridProps}
            >
                <Sorting mode="none" />
                {getColumns()}
                <MasterDetail enabled={props.render != undefined} render={props.render} autoExpandAll={props.expandAll}/>
                
            </DataGrid>
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={onHidingToast}
                displayTime={15000}
            />
            { props.gridHelpId &&
                <Tooltip
                    target={`#${props.gridHelpId}`}
                    showEvent="dxhoverstart"
                    hideEvent="dxhoverend"
                    position={"left"}
                    contentRender={() => <div className={styles.tooltipStyle}>{ props.gridHelpText }</div>}
                />
            }
        </>
    ); 
}

export default MasterDataGrid;
